import { formatString } from 'core/utilities';
import { Bff } from 'core/services';
import { OrderSuccesButton } from 'ui/components/templates';
import { Link, ResponsiveFloraTypography } from 'ui/components/primitives';

import { Boleto } from '../Boleto';
import { CREDIT_CARD_CONST } from './CreditCardWrapper.d';
import { CreditCard } from './CreditCardWrapper.style';
import { theme } from 'ui/theme';
import type { CreditCardProps } from './CreditCardWrapper.d';

const CreditCardWrapper = ({
  deliveryDate,
  description,
  expirationDate,
  icon,
  iconColor,
  linkButton,
  onClick,
  orderCode,
  paymentMethod,
  status,
  title,
  titleButton,
  value,
  trackUserClicks,
}: CreditCardProps) => {
  const titleFormat = formatString(title, {
    orderId: orderCode,
  });

  return (
    <CreditCard.Component data-testid={CREDIT_CARD_CONST.TEST_ID}>
      <CreditCard.IconWrapper data-icon-color={iconColor}>{icon}</CreditCard.IconWrapper>
      <ResponsiveFloraTypography
        as="h1"
        color={`${theme.colors.action.nonInteractive.emphasis}`}
        fontSize="subtitle"
        css={{ margin: 0, textAlign: 'center' }}
      >
        {titleFormat}
      </ResponsiveFloraTypography>

      {description && <CreditCard.Subtitle textAlign="center">{description}</CreditCard.Subtitle>}

      {status === Bff.ORDER_STATUS.PAYMENT_PROCESS && (
        <Boleto
          deliveryDate={deliveryDate}
          expirationDate={expirationDate}
          paymentMethod={paymentMethod}
          value={value}
          trackUserClicks={trackUserClicks}
        />
      )}

      {linkButton ? (
        <>
          <OrderSuccesButton.ButtonWrapper>
            <Link to={linkButton} onClick={trackUserClicks}>
              <OrderSuccesButton.ButtonSolid stretch>{titleButton}</OrderSuccesButton.ButtonSolid>
            </Link>
            <OrderSuccesButton.ButtonGhost onClick={onClick} stretch>
              Voltar para o início
            </OrderSuccesButton.ButtonGhost>
          </OrderSuccesButton.ButtonWrapper>
        </>
      ) : (
        <OrderSuccesButton.ButtonSolid onClick={onClick} stretch>
          Voltar para o início
        </OrderSuccesButton.ButtonSolid>
      )}
    </CreditCard.Component>
  );
};
export default CreditCardWrapper;
